import jquery from 'jquery'

export default {
  getData: function (bestand, dt, callback) {
    jquery.ajax({
      type: 'GET',
      contentType: 'application/json; charset=utf-8',
      dataType: 'jsonp',
      url: 'https://vanlerberghe.vdc-soft.be/' + bestand + '.php',
      data: dt,
      success: function (data) {
        callback(data)
      },
      beforeSend: function (jqXHR) {
        jqXHR.setRequestHeader('Accept-Encoding', 'deflate')
      },
      error: function (data) {
        // fout('Fout bij verbinding')
        callback({data: [], status: 'NOK'})
      }
    })
  },
  setData: function (bestand, dt, callback) {
    jquery.ajax({
      type: 'POST',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      url: 'https://vanlerberghe.vdc-soft.be/' + bestand + '.php',
      data: JSON.stringify(dt),
      success: function (data) {
        callback(data)
      },
      error: function (data) {
        // fout('Fout bij verbinding')
        console.log('error upload')
        callback({data: [], status: 'NOK'})
      }
    })
  },
  baseURL: function () {
    return 'https://vanlerberghe.vdc-soft.be/'
  }
}



// WEBPACK FOOTER //
// ./src/datareq.js